import serviceTaskTypesApiService from '@/services/api/ServiceTaskTypes'

const emptyModel = {
  id: null,
  title: null,
  checklist_use: false,
  checklist_browse_all: false,
  checklist_extras: false,
  order: null,
  description: null
}

class ServiceTaskType {
  constructor() {
    this.api = serviceTaskTypesApiService
    this.emptyModel = emptyModel
  }
}

let serviceTaskType = new ServiceTaskType()

export default serviceTaskType
